export class Margin {
  Desktop: Margins = new Margins();
  Tablet: Margins = new Margins();
  Mobile: Margins = new Margins();
}

export class Margins {
  Top?: string;
  Left?: string;
  Bottom?: string;
  Right?: string;
}
